module.exports = __webpack_public_path__ + "img/code.4916a50c.png";